export const BUGSNAG = {
  API_KEY: import.meta.env.VITE_BUGSNAG_API_KEY
}
